module.exports = __webpack_public_path__ + "static/img/solution_intel.53c34cfa.png";